module.exports = "<block-card><h1 translate=\"{{$ctrl.heading}}\"></h1><h2 translate=\"{{$ctrl.subtitle}}\" ng-if=\"$ctrl.subtitle\"></h2></block-card>";